/* eslint-disable @next/next/no-img-element */
import * as React from 'react';

import { useParams } from 'next/navigation';

interface Props {
  className?: string;
}

const EcosystemMiddleLayer: React.FC<Props> = ({ className }) => {
  const { tenant } = useParams<{ tenant: string }>();
  const prefix = tenant === 'technologies' ? 'pt-' : '';

  return (
    <img
      alt="Kvant Ecosystem - Layer 2"
      src={`/public/${prefix}ecosystem-layer2.png`}
      className={className}
    />
  );
};

export default EcosystemMiddleLayer;
